<div *ngIf="notification" class="notification" [ngClass]="notification.type">
  <div class="message">{{ notification.message }}</div>
  <button class="close-button" (click)="dismiss()" aria-label="Close notification">×</button>
</div>
